module.exports = __webpack_public_path__ + "media/images/logo-compleet-4b2faae3b871f7451fd5e5dd83cde81b.svg";